import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { LayoutAdminModule } from '../../layout/admin/layout-admin.module';
import { SharedModule } from '../../shared/shared.module';
import { IntegrationMonitorComponent } from './integration-monitor.component';
import { InboundPanelComponent } from './inbound-panel.component';
import { LotsPanelComponent } from './lots-panel.component';
import { WebhookPanelComponent } from './webhook-panel.component';
import { IntegrationMonitorRoutes } from './integration-monitor.routes';

@NgModule({
    declarations: [IntegrationMonitorComponent, InboundPanelComponent, LotsPanelComponent, WebhookPanelComponent],
    imports: [
        CommonModule,
        FormsModule,
        MatCardModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatProgressSpinnerModule,
        MatIconModule,
        IntegrationMonitorRoutes,
        LayoutAdminModule,
        SharedModule
    ]
})
export class IntegrationMonitorModule {}
